import styled from "@emotion/styled";
import theme from "@theme/";

const PropertyDetailsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 24px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
`;

const PropertyInfo = styled.div`
  width: 100%;
  padding: 0;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  margin-bottom: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const GroupCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1.25rem;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  height: 100%;
  width: 100%;
  min-width: 0;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }

  &:focus-within {
    outline: 2px solid rgba(227, 110, 0, 0.3);
    outline-offset: 2px;
  }

  @media (min-width: 640px) {
    padding: 2rem;
    border-radius: 1.5rem;
  }

  @media (min-width: 1024px) {
    padding: 2.5rem;
  }

  @media (min-width: 1280px) {
    padding: 3rem;
  }
`;

const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;

  @media (min-width: 640px) {
    margin-bottom: 2rem;
  }

  @media (min-width: 1024px) {
    margin-bottom: 2.5rem;
  }

  @media (min-width: 1280px) {
    margin-bottom: 3rem;
  }
`;

const GroupTitle = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  background: ${theme.gradient.themeGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.3px;
  line-height: 1.2;
  margin: 0;

  @media (min-width: 640px) {
    font-size: 1.125rem;
  }

  @media (min-width: 1024px) {
    font-size: 1.25rem;
  }

  @media (min-width: 1280px) {
    font-size: 1.5rem;
  }
`;

const GroupContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding: 0;
  width: 100%;
  min-width: 0;

  @media (max-width: 1200px) {
    gap: 14px;
  }

  @media (max-width: 1024px) {
    gap: 12px;
  }

  @media (max-width: 768px) {
    gap: 10px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

const InfoRow = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 0.75rem;
  border: 1px solid rgba(227, 110, 0, 0.1);
  transition: all 0.3s ease;
  width: 100%;
  min-width: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    border-color: rgba(227, 110, 0, 0.2);
    transform: translateY(-1px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 1200px) {
    padding: 14px;
  }

  @media (max-width: 1024px) {
    padding: 12px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 8px;
    gap: 6px;
  }
`;

const InfoLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-right: 1.5rem;

  @media (max-width: 1024px) {
    font-size: 13px;
    gap: 6px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    gap: 4px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

const InfoValue = styled.div`
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;

  @media (max-width: 1024px) {
    font-size: 13px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

const SizeInput = styled.input`
  width: 140px;
  padding: 8px 12px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  font-size: 14px;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #e36e00;
    box-shadow: 0 0 0 3px rgba(227, 110, 0, 0.1);
  }
`;

const SizeUnitSelect = styled.select`
  margin-left: 10px;
  padding: 8px 12px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  font-size: 14px;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #e36e00;
    box-shadow: 0 0 0 3px rgba(227, 110, 0, 0.1);
  }
`;

const ImageContainer = styled.div`
  flex: 1;
  padding: 0;
  width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`;

const Image = styled.div`
  width: 100%;
  max-width: 400px;
  height: 280px;
  border-radius: 20px;
  overflow: hidden;
  background: #f8fafc;
  box-shadow: 0 4px 15px rgba(227, 110, 0, 0.15);
  border: 1px solid rgba(227, 110, 0, 0.1);
  position: relative;

  @media (max-width: 768px) {
    height: 250px;
  }
`;

const SC = {
  PropertyDetailsContainer,
  PropertyInfo,
  InfoGrid,
  GroupCard,
  GroupHeader,
  GroupTitle,
  GroupContent,
  InfoRow,
  InfoLabel,
  InfoValue,
  SizeInput,
  SizeUnitSelect,
  ImageContainer,
  Image,
};

export default SC;
